import { Component, Input, OnInit } from '@angular/core';
import { TechnicalCriteriaEvaluationTypeEnum } from '../../../models/product-evaluation-tasks/enums/TechnicalCriteriaEvaluationTypeEnum';

@Component({
  selector: 'app-product-evaluation-task-type',
  standalone: false,
  templateUrl: './product-evaluation-task-type.component.html'
})
export class ProductEvaluationTaskTypeComponent implements OnInit {

  @Input({ required: true }) evaluationType: TechnicalCriteriaEvaluationTypeEnum;
  evaluationTypeEnum = TechnicalCriteriaEvaluationTypeEnum;

  constructor() { }

  ngOnInit() {
  }

}
